import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AcompMetasDistribuicaoLimitesComponent } from "./acomp-metas-distribuicao-limites/acomp-metas-distribuicao-limites.component";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";
import { DominiosResolver } from "src/app/shared/resolvers/dominios.resolver";

const routes:Routes = [
    {
        path: 'exportacao-agente-financeiro',
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        data: { canReuse: false}, 
        children: [
            {
                path: 'acomp-metas-distribuicao-limites',
                component: AcompMetasDistribuicaoLimitesComponent,
                resolve: { dominios: DominiosResolver },
            },
            {
                path: 'acomp-metas-distribuicao-limites-gestor',
                component: AcompMetasDistribuicaoLimitesComponent,
                data: { perfil: 'gestor' },
                resolve: { dominios: DominiosResolver },
            },
            ]
    },
]

@NgModule({
    imports:[RouterModule.forChild(routes)],
    exports:[RouterModule]
})
export class ExportacaoAgenteFiananceiroRoutingModule{}